const $ = require('jquery');
global.$ = global.jQuery = $;

require('slick-carousel');
// NOTE: サイトのデザインと合わないため、CSSは読み込まない
// require('slick-carousel/slick/slick.css');
// require('slick-carousel/slick/slick-theme.css');

require('bootstrap');
